import BaseApi from './BaseApi'
import { serialize } from 'object-to-formdata'

export default class Archive extends BaseApi {
  requestArchive (params) {
    return this.axios.post('/catalog/archive/request-archive', params)
  }

  categoryList () {
    return this.axios.get('/catalog/archive/category-list')
  }

  productIds (params, options = {}) {
    if (Object.values(params).some((value) => value instanceof File)) {
      params = serialize(params)
      options = {
        ...options,
        ...{
          headers: this.defaultPostHeaders
        }
      }
    }
    return this.axios.post('/catalog/archive/product-ids', params, options)
  }

  availableCategories (params) {
    return this.axios.post('/catalog/archive/available-categories', params)
  }

  lastEmails (params) {
    return this.axios.get('/catalog/archive/last-emails', params)
  }

  deleteEmail (email, params) {
    return this.axios.delete('/catalog/archive/delete-email/' + email, params)
  }
}
